import { useEffect, useState } from "react";

const useRazorpay = ({ onLoad }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (
      document.querySelector(
        'script[src="https://checkout.razorpay.com/v1/checkout.js"]'
      )
    ) {
      setIsLoaded(true);
      if (onLoad) onLoad();
      return;
    }

    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;

    script.onload = () => {
      setIsLoaded(true);
      if (onLoad) onLoad();
    };

    script.onerror = () => {
      console.error("Razorpay SDK failed to load.");
      setIsLoaded(false);
    };

    document.body.appendChild(script);

    return () => {
      const existingScript = document.querySelector(
        'script[src="https://checkout.razorpay.com/v1/checkout.js"]'
      );
      if (existingScript) {
      }
    };
  }, [onLoad]);

  return isLoaded;
};

export default useRazorpay;
